import React from 'react';
import './App.scss';
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';

import createHistory from 'history/createBrowserHistory';
import httpService from './Services/Public/httpService';
import panelLayout from './Pages/Private/panelLayout';
import login from './Pages/Public/login/login';
import register from './Pages/Public/register/register';
import layout from './Pages/Public/layout/layout';
import {PrivateRoute} from "./Components/PrivateRoute";
import confirmAuth from "./Pages/Public/confirmAuth";
import {IsLoginRoute} from "./Components/IsLoginRoute";
import notFound from "./Pages/Public/notFound";
import {BackTop} from "antd";

const history = createHistory();
httpService.setupInterceptors(history);

const App: React.FC = () => {
  return (
    <div className=" bitspco  ltr">
      <Router>
        <div>
          <Switch>
          <Route exact path="/" component={layout} />
          <IsLoginRoute path="/login" component={login} />
          <IsLoginRoute path="/register" component={register} />
          <IsLoginRoute  path="/confirm" component={confirmAuth} />
          <PrivateRoute  path="/panel" component={panelLayout} />

          <Route path='/notFound' component={notFound} />
          <Redirect from='*' to='/notFound' />
          </Switch>
        </div>
      </Router>

      <div>
        <BackTop  />
      </div>
    </div>
  );
};

export default App;
